import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { DEVICE_MODAL_TYPE, YN_TYPE } from 'types/enumType';

export const deviceInfoSchema = yupResolver(
  yup.object({
    id: yup.number().defined(),
    name: yup.string().trim().required('Zone이름을 입력해주세요'),
    type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
    manage: yup.mixed<YN_TYPE>().optional(),
    activate: yup.mixed<YN_TYPE>().optional(),
  }),
);

export const equipmentInfoSchema = yupResolver(
  yup.object({
    id: yup.number().defined(),
    code: yup.string().defined(),
    itemCode: yup.string().required('설비 코드를 입력해주세요'),
    eqCd: yup.string().max(10, '코드는 최대 10자리입니다').defined(),
    mdmCode: yup.string().defined(),
    name: yup.string().trim().required('설비 이름을 입력해주세요'),
    type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
    activate: yup.mixed<YN_TYPE>().optional(),
  }),
);

export const planImageSchema = yupResolver(yup.object({
  typeId: yup.number().defined(),
  type: yup.mixed<DEVICE_MODAL_TYPE>().defined(),
  image: yup.mixed<FileList>().required('이미지를 등록해주세요')
    .test("file", "이미지를 등록해주세요", (value: FileList) => !!value?.length)
    .test("fileSize", "파일 사이즈가 큽니다", (value: FileList) => {
      if (!value?.length) {
        return false;
      }
      return value[0].size <= 10000000
    })
}))
